import { render } from "./StudentRegister.vue?vue&type=template&id=1de90ed1&scoped=true"
import script from "./StudentRegister.vue?vue&type=script&lang=js"
export * from "./StudentRegister.vue?vue&type=script&lang=js"

import "./StudentRegister.vue?vue&type=style&index=0&id=1de90ed1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de90ed1"]])

export default __exports__